import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';

import { SetupProfileWizard } from './resources/components/SetupProfileWizard/SetupProfileWizard';
import { useProfileSetupEmailPageData } from './resources/hooks/useProfileSetupEmailPageData';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    useProfileSetupEmailPageData();

    const [layoutSize, setLayoutSize] = useState<'xsmall' | 'large'>('xsmall');

    const handleShowPreAhaMoment = useCallback(() => {
        setLayoutSize('large');
    }, []);

    return (
        <SimpleLayout size={layoutSize}>
            <Helmet>
                <title>{messages.pageTitle}</title>
            </Helmet>

            <SimpleLayout.Content>
                <SetupProfileWizard onShowPreAhaMoment={handleShowPreAhaMoment} />
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
